/**
 * Bouton avec branding automatique pour les formulaires publics (référent + candidat)
 */
import { Button, ButtonProps } from '@/components/ui/button';
import { useReferentBrandingColors } from '@/hooks/useReferentBrandingColors';

interface BrandingSettings {
  enabled: boolean;
  logo_url?: string;
  primary_color?: string;
}

interface BrandedButtonProps extends ButtonProps {
  branding?: BrandingSettings | null;
}

export const BrandedButton = ({ 
  branding, 
  style, 
  variant = "brand",
  ...props 
}: BrandedButtonProps) => {
  const colors = useReferentBrandingColors(branding);
  
  // Applique le branding seulement pour les variants qui utilisent la couleur primary
  const shouldApplyBranding = variant === "brand" || !variant;
  
  const brandedStyle = shouldApplyBranding ? {
    backgroundColor: colors.primary,
    borderColor: colors.primary,
    ...style
  } : style;

  return (
    <Button 
      variant={variant}
      style={brandedStyle} 
      {...props} 
    />
  );
};
